module.exports = __webpack_public_path__ + "img/circle_active_large.e9c80e85.png";